/*!
=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// javascipt plugin for creating charts
import Chart from "chart.js";
// node.js library that concatenates classes (strings)
import React from "react";
// react plugin used to create charts
// reactstrap components
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Container, DropdownItem, DropdownMenu,
    DropdownToggle,
    Progress,
    Row,
    UncontrolledDropdown,
} from "reactstrap";
import {chartOptions, parseOptions,} from "../../../variables/adminCharts";

import _ from "lodash";
import SubscribedUserCardsHeader from "../../../components/Headers/SubscribedUserCardsHeader";
import ReviewService from "../../../services/reviewService";
import UtilService from "../../../services/utilService";
import DownloadUtil from "../../../util/downloadUtil";
import Rating from "react-rating";
import ReportsKpiTable from "../../../components/dashboard/ReportsKpiTable";

const items = [
    {
        src: 'https://picsum.photos/id/123/1200/400',
        altText: 'Slide 1',
        caption: 'Slide 1',
        key: 1,
    },
    {
        src: 'https://picsum.photos/id/456/1200/400',
        altText: 'Slide 2',
        caption: 'Slide 2',
        key: 2,
    },
    {
        src: 'https://picsum.photos/id/678/1200/400',
        altText: 'Slide 3',
        caption: 'Slide 3',
        key: 3,
    },
];


class SubscribedUserDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeNav: 1,
            chartExample1Data: "data1",
            activeIndex: 0,
            animating: false,
            score: 0,
            totalReviewsSent: 0,
            totalUnansweredReviews: 0,
            totalAnsweredReviews: 0,
            breakDownScore: {}


        };
        if (window.Chart) {
            parseOptions(Chart, chartOptions());
        }
        this.filterByContentType = this.filterByContentType.bind(this);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this)
    }

    filterByContentType = (data, type) => {
        return _.filter(data, {contentType: type});
    };


    next = () => {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({activeIndex: nextIndex})
    };

    previous = () => {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
        this.setState({activeIndex: nextIndex})
    };

    goToIndex = (newIndex) => {
        if (this.state.animating) return;
        this.setState({activeIndex: newIndex})
    };

    componentDidMount() {
        ReviewService.userReviewDetails().then((response) => {
            this.setState({...response}, ()=> console.log(this.state));
        })
    }

    getColor = (score) => {
        if (score >= 4) {
            return "green";
        } else if (score > 2) {
            return "orange";
        }else if (score > 0) {
            return "red";
        } else {
            return "red"
        }
    };

    toggleNavs = (e, index) => {
        e.preventDefault();
        this.setState({
            activeNav: index,
            chartExample1Data:
                this.state.chartExample1Data === "data1" ? "data2" : "data1",
        });
    };


    render() {
        return (
            <>
                <Container className="mt-6" fluid>
                    <Row>
                        <Col md="6" xl="3">
                            <Card className="bg-gradient-primary border-0">
                                <CardBody>
                                    <Row>
                                        <div className="col">
                                            <CardTitle
                                                tag="h3"
                                                className="text-uppercase text-muted mb-0 text-white"
                                            >
                                                Review Score
                                            </CardTitle>
                                            <div className="d-flex justify-content-end">
                                              <span className="h1 font-weight-bold mb-0 text-white">
                                                {typeof this.state.score === 'number' ? this.state.score.toFixed(2) : '0.00'} / 5
                                              </span>
                                            </div>
                                            <Progress
                                                className="progress-xs mt-3 mb-0"
                                                max="5"
                                                value={this.state.score || 0}
                                                color={this.getColor(this.state.score)}
                                            />
                                        </div>
                                    </Row>
                                    <p className="mt-3 mb-0 text-sm">
                                        <a
                                            className="text-nowrap text-white font-weight-600"
                                            href="#pablo"
                                            onClick={e => e.preventDefault()}
                                        >
                                            {/*See details*/}
                                        </a>
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="6" xl="3">
                            <Card className="bg-gradient-info border-0">
                                <CardBody>
                                    <Row>
                                        <div className="col">
                                            <CardTitle
                                                tag="h3"
                                                className="text-uppercase text-muted mb-0 text-white"
                                            >
                                                Total Invites Sent
                                            </CardTitle>
                                            <div className="d-flex justify-content-end">
                                              <span className="h1 font-weight-bold mb-0 text-white">
                                                {this.state.totalReviewsSent || 0}/ {this.state.totalReviewsSent || 0}
                                              </span>
                                            </div>
                                            <Progress
                                                className="progress-xs mt-3 mb-0"
                                                max={this.state.totalReviewsSent || 0}
                                                value={this.state.totalReviewsSent || 0}
                                                color="success"
                                            />
                                        </div>
                                    </Row>
                                    <p className="mt-3 mb-0 text-sm">
                                        <a
                                            className="text-nowrap text-white font-weight-600"
                                            href="#pablo"
                                            onClick={e => e.preventDefault()}
                                        >
                                            {/*See details*/}
                                        </a>
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="6" xl="3">
                            <Card className="bg-gradient-gray border-0">
                                <CardBody>
                                    <Row>
                                        <div className="col">
                                            <CardTitle
                                                tag="h3"
                                                className="text-uppercase text-muted mb-0 text-white"
                                            >
                                                Answered Invites
                                            </CardTitle>
                                            <div className="d-flex justify-content-end">
                                              <span className="h1 font-weight-bold mb-0 text-white">
                                                {this.state.totalAnsweredReviews || 0}/{this.state.totalReviewsSent || 0}
                                              </span>
                                            </div>
                                            <Progress
                                                className="progress-xs mt-3 mb-0"
                                                max={this.state.totalReviewsSent || 0}
                                                value={this.state.totalAnsweredReviews || 0}
                                                color="success"
                                            />
                                        </div>
                                        {/*<Col className="col-auto">
                                            <UncontrolledDropdown>
                                                <DropdownToggle
                                                    size="sm"
                                                    color="neutral"
                                                    className="mr-0"
                                                >
                                                    <i className="fas fa-ellipsis-h" />
                                                </DropdownToggle>
                                                <DropdownMenu right>
                                                    <DropdownItem
                                                        href="#pablo"
                                                        onClick={e => e.preventDefault()}
                                                    >
                                                        Action
                                                    </DropdownItem>
                                                    <DropdownItem
                                                        href="#pablo"
                                                        onClick={e => e.preventDefault()}
                                                    >
                                                        Another action
                                                    </DropdownItem>
                                                    <DropdownItem
                                                        href="#pablo"
                                                        onClick={e => e.preventDefault()}
                                                    >
                                                        Something else here
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </Col>*/}
                                    </Row>
                                    <p className="mt-3 mb-0 text-sm">
                                        <a
                                            className="text-nowrap text-white font-weight-600"
                                            href="#pablo"
                                            onClick={e => e.preventDefault()}
                                        >
                                            {/*See details*/}
                                        </a>
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="6" xl="3">
                            <Card className="bg-gradient-danger border-0">
                                <CardBody>
                                    <Row>
                                        <div className="col">
                                            <CardTitle
                                                tag="h3"
                                                className="text-uppercase text-muted mb-0 text-white"
                                            >
                                                Unanswered Invites
                                            </CardTitle>
                                            <div className="d-flex justify-content-end">
                                              <span className="h1 font-weight-bold mb-0 text-white">
                                                {this.state.totalUnansweredReviews || 0}/{this.state.totalReviewsSent || 0}
                                              </span>
                                            </div>
                                            <Progress
                                                className="progress-xs mt-3 mb-0"
                                                max={this.state.totalReviewsSent || 0}
                                                value={this.state.totalUnansweredReviews || 0}
                                                color="success"
                                            />
                                        </div>
                                    </Row>
                                    <p className="mt-3 mb-0 text-sm">
                                        <a
                                            className="text-nowrap text-white font-weight-600"
                                            href="#pablo"
                                            onClick={e => e.preventDefault()}
                                        >
                                            {/*See details*/}
                                        </a>
                                    </p>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row key={UtilService.uuidv4()} className="align-items-lg-start mb-4 p-3 border rounded" style={{ backgroundColor: "#f8f9fe" }}>
                        {/* Column 1: Logo */}
                        <Col xs="12" md="2" className="text-center mb-3 mb-md-0">
                            <img
                                src={this.state.brandLogoUID === null ? require("assets/img/brand/companies.jpeg") :
                                    this.state.brandLogoUID && DownloadUtil.generateUrl(this.state.brandLogoUID)}
                                alt="Company Logo"
                                style={{ width: "156px", height: "156px", objectFit: "contain" }}
                            />
                        </Col>

                        {/* Column 2: Company Name and Score */}
                        <Col xs="12" md="3" className="mb-3 mb-md-0">
                            <h4 className="font-weight-bold"><b>{this.state.companyName}</b></h4>
                            <p>Average Score: {this.state.score?.toFixed(1) ?? "0.0"}/5</p>
                            <Rating
                                readonly
                                initialRating={this.state.score}
                                emptySymbol={<i className="fa fa-star text-muted"/>}
                                fullSymbol={<i className="fa fa-star text-warning"/>}
                                fractions={2}
                                title={this.state.score?.toFixed(1)}
                            />
                            <p>Total Reviews - ({this.state.breakDownScore?.totalReviews || 0})</p>
                        </Col>

                        {/* Column 3: Review Count and Breakdown */}
                        <Col xs="12" md="6">
                            {/*<p><b><strong>Breakdown:</strong></b> {item.scoreBreakdown?.breakdown?.length ?? 0}</p>*/}

                            {this.state.breakDownScore?.breakdown?.length > 0 ? (
                                <Row>
                                    {this.state.breakDownScore.breakdown.map((entry, index) => (
                                        <Col key={index} xs="12" sm="12" className="mb-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span style={{ fontSize: "0.9rem" }}>{entry.question}:</span>
                                                <span style={{ whiteSpace: "nowrap", marginLeft: "0.5rem" }}>
                                                <Rating
                                                    readonly
                                                    initialRating={entry.breakdownScore}
                                                    emptySymbol={<i className="fa fa-star text-muted" />}
                                                    fullSymbol={<i className="fa fa-star text-warning" />}
                                                    fractions={2}
                                                    title={entry.breakdownScore.toFixed(1)}
                                                />
                                                <span className="ml-2">{entry.breakdownScore.toFixed(1)}/5</span>
                                            </span>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            ) : (
                                <p className="text-muted mt-2">No breakdown available</p>
                            )}
                        </Col>
                    </Row>
                    <ReportsKpiTable />
                </Container>
            </>
        );
    }
}

export default SubscribedUserDashboard;
